export default __webpack_public_path__ + "assets/a880c13df3c8edbd14d78a8d455141b8.jpg";